"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const BaseBuilder_1 = __importDefault(require("./BaseBuilder"));
class NodeBuilder extends BaseBuilder_1.default {
    node;
    constructor(nodeSeed) {
        super();
        this.node = { ...nodeSeed, blueprintId: (0, uuid_1.v4)() };
    }
    build() {
        try {
            this.validate(this.node);
            return lodash_1.default.cloneDeep(this.node);
        }
        catch (error) {
            throw Error(`Error when building: ${error.message}`);
        }
    }
}
exports.default = NodeBuilder;
